import styled from 'styled-components';

export const FeaturedContentContainer = styled.div`
  border-radius: 3px;
  margin-bottom: 50px;
  width: 90%;
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.25);
  @media (max-width: 576px) {
    width: 100%;
  }
  .featured-content--copy-container {
    height: 100%;
    background-color: white;
    .featured-content--copy {
      padding: 0px 30px;

      .featured-content--title {
        margin-bottom: 20px;
        width: 95%;
      }
    }
  }
  .simple-card {
    margin: 15px 0 0 0;
    p {
      font-size: 23px;
    }
  }

  .featured-content--headingkicker {
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 110%;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 20px;
    @media (max-width: 576px) {
      font-size: 14px;
    }
  }
  .featured-content--cta {
    border-radius: 27px !important;
    font-size: 14px;
    svg {
      stroke: white;
      margin-left: 5px;
    }
    @media (max-width: 576px) {
      margin-top: 30px;
    }
  }
  .featured-content--image {
  }
`;
